module.exports = __webpack_public_path__ + "media/images/cambridge_logo_2-97122f9c01213e31eb697d5cedf6613f.png";